import { Link } from 'react-router-dom';

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Navbar */}
      <header className="border-b border-gray-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/">
            <img
              src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/4ab61485feffac5558181f99f1be66f6.png"
              alt="Körperformen Pinneberg"
              className="h-9 w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="text-xs font-medium text-gray-500 hover:text-gray-900 transition-colors flex items-center gap-1.5 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line text-sm"></i>
            </div>
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <h1
          className="text-3xl md:text-4xl font-bold text-gray-900 mb-10"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Datenschutzerklärung
        </h1>

        <div className="space-y-10 text-gray-600 text-sm leading-relaxed" style={{ fontWeight: 300 }}>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
            <h3 className="text-sm font-semibold text-gray-800 mt-5 mb-2">Datenerfassung auf dieser Website</h3>
            <p>
              <strong className="font-medium text-gray-700">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
            </p>
            <p className="mt-3">
              <strong className="font-medium text-gray-700">Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen – z. B. durch das Ausfüllen eines Kontaktformulars. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            </p>
            <p className="mt-3">
              <strong className="font-medium text-gray-700">Wofür nutzen wir Ihre Daten?</strong><br />
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Wenn Sie über die Website eine Anfrage stellen, werden Ihre Daten zur Bearbeitung der Anfrage und für mögliche Anschlussfragen genutzt.
            </p>
            <p className="mt-3">
              <strong className="font-medium text-gray-700">Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              2. Hosting
            </h2>
            <p>
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              3. Allgemeine Hinweise und Pflichtinformationen
            </h2>
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            <h3 className="text-sm font-semibold text-gray-800 mt-5 mb-2">Hinweis zur verantwortlichen Stelle</h3>
            <p>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              Körperformen Pinneberg – EMS Gesundheitsstudio<br />
              Elmshorner Str. 3, 25421 Pinneberg<br />
              Telefon: <a href="tel:017620023034" className="text-[#1A5C3D] hover:underline cursor-pointer">0176 20023034</a><br />
              E-Mail: <a href="mailto:Pinneberg@kformen.com" className="text-[#1A5C3D] hover:underline cursor-pointer">Pinneberg@kformen.com</a>
            </p>
            <h3 className="text-sm font-semibold text-gray-800 mt-5 mb-2">Speicherdauer</h3>
            <p>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben.
            </p>
            <h3 className="text-sm font-semibold text-gray-800 mt-5 mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p>
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              4. Datenerfassung auf dieser Website
            </h2>
            <h3 className="text-sm font-semibold text-gray-800 mb-2">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="mt-3">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
            </p>
            <p className="mt-3">
              Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
            </p>
            <h3 className="text-sm font-semibold text-gray-800 mt-5 mb-2">Anfrage per E-Mail oder Telefon</h3>
            <p>
              Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
              5. Ihre Rechte
            </h2>
            <p>
              Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
            </p>
            <ul className="mt-3 space-y-1.5 list-disc list-inside">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständige Aufsichtsbehörde in Schleswig-Holstein ist das Unabhängige Landeszentrum für Datenschutz Schleswig-Holstein (ULD), Holstenstraße 98, 24103 Kiel.
            </p>
            <p className="mt-3">
              Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:<br />
              <a href="mailto:Pinneberg@kformen.com" className="text-[#1A5C3D] hover:underline cursor-pointer">Pinneberg@kformen.com</a>
            </p>
          </section>

        </div>
      </main>

      <footer className="border-t py-8 px-6" style={{ backgroundColor: '#0D1811', borderColor: 'rgba(93,196,142,0.1)' }}>
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)', fontFamily: 'Inter, sans-serif' }}>
            &copy; {new Date().getFullYear()} Körperformen Pinneberg. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-5">
            <Link to="/impressum" className="text-xs whitespace-nowrap hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.25)', fontFamily: 'Inter, sans-serif' }}>
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-xs whitespace-nowrap" style={{ color: 'rgba(255,255,255,0.5)', fontFamily: 'Inter, sans-serif' }}>
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
